import { selectCurrentTeamsById } from 'ducks/teams/selectors'
import { createSelector } from 'reselect'
import { selectCurrentTicketAssignedGroupId } from './selectCurrentTicketAssignedGroupId'

export const selectCurrentTicketAssignedGroup = createSelector(
  selectCurrentTicketAssignedGroupId,
  selectCurrentTeamsById,
  (groupId, groupsById) => (groupId ? groupsById[groupId] : undefined)
)
